import { useState } from 'react'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import ErrorModal from 'modules/integrations_primobox/components/ErrorModal'
import StatusTag from 'modules/integrations_primobox/components/StatusTag'
import type Status from 'modules/integrations_primobox/lib/interfaces/Status'

interface Props {
  title?: string
  status: Status
  inModal: boolean
}

const StatusBlock = ({ status, title, inModal }: Props) => {
  const [showErrorModal, setShowErrorModal] = useState(false)

  return (
    <>
      <Box
        padding={inModal ? undefined : 's32'}
        background={inModal ? undefined : 'grey200'}
        borderRadius={{ all: 'abs008' }}
      >
        {title && <Text.Normal weight="medium">{title}</Text.Normal>}

        <StatusTag status={status} />

        {status.messages.length > 0 && inModal && (
          <Box paddingTop="s16">
            {status.messages.map((message, index) => (
              <Text.Normal key={index} size="200">
                {message}
              </Text.Normal>
            ))}
          </Box>
        )}

        {status.messages.length > 0 && !inModal && (
          <Box alignItems="flexEnd" paddingTop="s16">
            <Button onClick={() => setShowErrorModal(true)} type="secondary">
              {i18n.t('integrations_primobox.error_modal.button')}
            </Button>
          </Box>
        )}
      </Box>

      {showErrorModal && !inModal && (
        <ErrorModal status={status} onClose={() => setShowErrorModal(false)} />
      )}
    </>
  )
}

export default StatusBlock
